import { ca } from '@cian/analytics';

const baseEvent = {
  category: 'card',
  name: 'oldevent',
};

export function trackClickVideo() {
  ca(
    'event',
    Object.assign(
      {
        action: 'tab_video_photo_block',
      },
      baseEvent,
    ),
  );
}

export function trackClickLayout() {
  ca(
    'event',
    Object.assign(
      {
        action: 'tab_layout_photo_block',
      },
      baseEvent,
    ),
  );
}

export function trackClickPhotos() {
  ca(
    'event',
    Object.assign(
      {
        action: 'tab_photos_photo_block',
      },
      baseEvent,
    ),
  );
}
